import React from "react";
import PropTypes from "prop-types";
import Loader from "./ControlBlock.loader";
import cname from "../../Style/style.module.scss";

/**
 * ControlBlock:
 *  - Component wraps SwitchButtonBlock and Slider Components
 *    and manages loader display
 */
export function ControlBlock(props) {
  return (
    <div className={cname.controlBlock}>
      {props.loading ? (
        <Loader />
      ) : (
        <div
          aria-label="animation controls"
          role="form"
          className={cname.controlItems}
        >
          {props.children}
        </div>
      )}
    </div>
  );
}

ControlBlock.propTypes = {
  /**
   * Boolean set to show loader
   */
  loading: PropTypes.bool,
  /**
   * List of child components
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};
